import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { useConsentManagement } from 'src/utils/fides/hooks/use-consent-management';
import GlobalHeader from 'components/global-header';
import GlobalFooter from 'components/global-footer-rebrand';
import { DutchiePrivacyFooter } from 'src/dispensary/core-menu/components/dutchie-privacy-footer';

type LayoutWithHeaderProps = {
  children: React.ReactNode;
  hideFooter?: boolean;
};

const LayoutWithHeader = forwardRef<HTMLDivElement, LayoutWithHeaderProps>((props, ref) => {
  const { hideFooter, children, ...otherProps } = props;
  const { isConsentManagementEnabled } = useConsentManagement();

  return (
    <Container ref={ref}>
      <GlobalHeader />
      <Content {...otherProps}>{children}</Content>
      {isConsentManagementEnabled && <DutchiePrivacyFooter />}
      {!hideFooter && (
        <DarkFooterWrap>
          <GlobalFooter />
        </DarkFooterWrap>
      )}
    </Container>
  );
});

export default LayoutWithHeader;

const Container = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const Content = styled.div`
  flex: 1 0 0%;
`;

const DarkFooterWrap = styled.div`
  background: #042017;

  && > div {
    background-color: #042017;
  }

  && div {
    background-color: #042017;
    border-bottom-color: rgba(243, 234, 216, 0.15);
    border-top-color: rgba(243, 234, 216, 0.15);
  }

  && a,
  && p,
  && span,
  && li {
    color: #cfc6b3;
  }

  && a:hover {
    color: #f3ead8;
  }

  && h3,
  && h4,
  && h5 {
    color: #f3ead8;
  }

  && svg path {
    fill: #cfc6b3;
  }
`;
